/**
 * @param {number} timeout - Number of milliseconds to sleep
 * @returns Promise that resolves itself after a certain timeout
 */
function sleep(timeout: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null);
    }, timeout);
  });
}

export { sleep };
